import Collection from 'lib/Collection';
import Visit from 'model/Visit';
import config from 'config';

export default Collection.extend({
	model: Visit,

	// Chargement des données depuis l'API ou depuis un fichier local
	url: config.url.visit,
	file: config.file.visit,

	comparator: function( visit )
	{
		return -visit.get('created_at');
	},

	toString: function() {
		return 'liste des visites';
	},

	getFilter: function( type )
	{
		if( type == 'draft' )
		{
			return function( visit ) { return visit.get('user_id') == app.getStore('user').get('id') && visit.has('todo') && visit.isVisible(); };
		}

		if( type == 'sent' )
		{
			return function( visit ) { return visit.get('user_id') == app.getStore('user').get('id') && !visit.has('todo') && visit.isVisible(); };
		}

		throw "Type de filtre inconnu : "+type;
	},

	getList: function( type )
	{
		return this.filter( this.getFilter( type ) );
	},

	getNb: function( type )
	{
		return _.size( this.getList( type ) );
	}
});
